import { createUseStyles } from 'react-jss'
import { BLACK } from '@omnilert/components'

export default createUseStyles({
  wrapper: ({ modal }) => ({
    '& :hover': {
      cursor: modal && 'pointer'
    }
  }),
  imageModal: {
    background: BLACK,
    height: '100%',
    position: 'fixed',
    right: 0,
    top: 0,
    width: '100%',
    zIndex: 99999
  },
  modalImage: {
    height: '100%',
    width: '100%',
    objectFit: 'contain'
  }
})
